export const FACEBOOK_DOMAIN = 'https://www.facebook.com';
